"use strict";
/**
 * WP-080: External Content Ingestion — self-logged diary v0.
 *
 * A teacher can log external CPD they've completed (courses attended outside
 * EduWrite). This is the v0 of external content ingestion — no SCORM/xAPI
 * integration (those enum values are reserved but not implemented).
 *
 * Design decisions (see WP-080 spec):
 * - `sourceType` includes 'external_self_logged' (implemented) plus 'scorm'
 *   and 'xapi' (reserved for future — the API rejects them with 422).
 * - `status` starts as 'pending'; a DSL/admin can verify or reject.
 * - `completedDate` is DATE (YYYY-MM-DD), not TIMESTAMP, to avoid DST issues.
 * - Evidence file is optional, stored in MinIO `content/{orgId}/cpd-evidence/`.
 * - All queries are org-scoped (tenant isolation).
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.EXTERNAL_CPD_STATUSES = exports.ACCEPTED_EXTERNAL_CPD_SOURCE_TYPES = exports.EXTERNAL_CPD_SOURCE_TYPES = void 0;
exports.isExternalCpdSourceType = isExternalCpdSourceType;
exports.isExternalCpdStatus = isExternalCpdStatus;
/**
 * Constant array of all valid ExternalCpdSourceType values.
 */
exports.EXTERNAL_CPD_SOURCE_TYPES = [
    'external_self_logged',
    'scorm',
    'xapi',
];
/**
 * The source types accepted by the API in v0.
 * SCORM and xAPI are reserved but NOT accepted — rejected with 422.
 */
exports.ACCEPTED_EXTERNAL_CPD_SOURCE_TYPES = [
    'external_self_logged',
];
/**
 * Type guard: returns true if the value is a valid ExternalCpdSourceType.
 */
function isExternalCpdSourceType(value) {
    return typeof value === 'string' && exports.EXTERNAL_CPD_SOURCE_TYPES.includes(value);
}
/**
 * Constant array of all valid ExternalCpdStatus values.
 */
exports.EXTERNAL_CPD_STATUSES = [
    'pending',
    'verified',
    'rejected',
];
/**
 * Type guard: returns true if the value is a valid ExternalCpdStatus.
 */
function isExternalCpdStatus(value) {
    return typeof value === 'string' && exports.EXTERNAL_CPD_STATUSES.includes(value);
}
